var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ul", { attrs: { id: "list-tasks" } }, [
    _c("li", [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.it.tipoOblea == 1,
              expression: "it.tipoOblea == 1"
            }
          ],
          attrs: { id: "oblea" }
        },
        [
          _c("div", { attrs: { id: "s1" } }, [
            _c("img", {
              staticStyle: { height: "52px" },
              attrs: { src: _vm.imagenProducto }
            })
          ]),
          _vm._v(" "),
          _c("div", { attrs: { id: "s2", title: _vm.item.producto } }, [
            _c("span", { attrs: { id: "titulo" } }, [
              _vm._v(_vm._s(_vm.item.producto))
            ])
          ]),
          _vm._v(" "),
          _c("div", { attrs: { id: "s22" } }, [
            _c("div", [
              _c("span", { staticClass: "label" }, [_vm._v("Precio:")]),
              _vm._v(" "),
              _c("span", { staticClass: "value" }, [
                _vm._v("$" + _vm._s(_vm._f("formatMoney")(_vm.item.precio)))
              ])
            ]),
            _vm._v(" "),
            _c("div", [
              _c("span", { staticClass: "label" }, [_vm._v("Subtotal:")]),
              _vm._v(" "),
              _c("span", { staticClass: "value" }, [
                _vm._v(
                  "$" +
                    _vm._s(
                      _vm._f("formatMoney")(_vm.it.cantidad * _vm.item.precio)
                    )
                )
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { attrs: { id: "s3" } }, [
            _c("div", { attrs: { id: "cc" } }, [
              _c("span", { attrs: { id: "label-cantidad" } }, [
                _vm._v("Cantidad")
              ]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.it.cantidad,
                    expression: "it.cantidad"
                  }
                ],
                staticClass: "cantidad",
                class: { cantidadInv: _vm.cantInvalida },
                attrs: { type: "text" },
                domProps: { value: _vm.it.cantidad },
                on: {
                  keyup: _vm.updateCantidad,
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.it, "cantidad", $event.target.value)
                  }
                }
              })
            ])
          ]),
          _vm._v(" "),
          _c("div", { attrs: { id: "s4" } }, [
            _c("img", {
              staticStyle: { width: "20px", height: "20px" },
              attrs: { id: "btnEliminarItem", src: "/dist/icon-delete.png" },
              on: { click: _vm.btnEliminarItem }
            })
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.it.tipoOblea == 2,
              expression: "it.tipoOblea == 2"
            }
          ],
          attrs: { id: "oblea-desc" }
        },
        [
          _c("div", { attrs: { id: "s1" } }),
          _vm._v(" "),
          _c("div", { attrs: { id: "s2" } }, [
            _c("span", { attrs: { id: "titulo" } }, [
              _vm._v(_vm._s(_vm.item.producto))
            ])
          ]),
          _vm._v(" "),
          _c("div", { attrs: { id: "s222" } }, [
            _c("span", { staticClass: "label-desc" }, [_vm._v("Descuento:")]),
            _vm._v(" "),
            _c("span", { staticClass: "value" }, [
              _vm._v(" $" + _vm._s(_vm._f("formatMoney")(_vm.item.precio)))
            ])
          ]),
          _vm._v(" "),
          _c("div", { attrs: { id: "s3" } }),
          _vm._v(" "),
          _c("div", { attrs: { id: "s4" } })
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2c9d5b21", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c9d5b21","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/pedido/ItemPedido.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-2c9d5b21","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/pedido/ItemPedido.vue
// module chunks = 0